"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferNFTForm = void 0;
const default_contract_action_1 = require("@components/default-contract-action");
const token_hooks_1 = require("@hooks/contracts/token.hooks");
const form_hooks_1 = require("@hooks/form.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
const text_input_1 = require("@shared-modules/components/text-input");
const react_1 = __importDefault(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const TransferNFTForm = (props) => {
    const { token, onClose } = props;
    const translator = (0, translation_hooks_1.useComponentTranslation)("transferNFTForm");
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const transferTokenTo = (0, token_hooks_1.useTokenTransfer)(token.tokenId, token.contractAddress);
    const { form, fieldHandlers, submit, validationResults } = (0, form_hooks_1.useForm)({
        initialData: helper_1.DEFAULT_FROM,
        validators: (0, helper_1.getValidators)(commonTranslator),
        submit: (form, { isValid }) => __awaiter(void 0, void 0, void 0, function* () {
            if (isValid) {
                const { blockNumber } = yield transferTokenTo(form.account);
                onClose(blockNumber);
            }
        }),
    });
    return (react_1.default.createElement("div", { className: "c-transfer-nft-form" },
        react_1.default.createElement("div", { className: "c-transfer-nft-form__header" }, translator("title")),
        react_1.default.createElement("div", { className: "c-transfer-nft-form__description" }, translator("description")),
        react_1.default.createElement("div", { className: "c-transfer-nft-form__field" },
            react_1.default.createElement(text_input_1.TextInput, { label: translator("accountLabel"), placeholder: translator("accountPlaceholder"), handleChange: fieldHandlers.account, error: validationResults.results.account, value: form.account })),
        react_1.default.createElement("div", { className: "c-transfer-nft-form__button" },
            react_1.default.createElement(default_contract_action_1.DefaultContractAction, { actionName: translator("transferButton"), actionHandler: submit }))));
};
exports.TransferNFTForm = TransferNFTForm;
